import { createChatBotMessage } from 'react-chatbot-kit';
import BotMessage from './components/BotMessage';

const botName = 'Optibot';

const config = {
  botName: botName,
  initialMessages: [
    createChatBotMessage(
      'Hello! I can help you find federal contract opportunities.\nTry asking something like: "Provide 5 contract opportunities for 541611 NAICS for the Department of Labor."'
    ),
  ],
  customComponents: {
    botChatMessage: (props) => <BotMessage content={props.message} loading={props.loading} loadingStage={props.loadingStage} {...props} />,
  },
};

export default config;
